import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import "./Style.css";

const EggMob = () => {
  let history = useHistory();
  const { t } = useTranslation();
  const languageText = localStorage.getItem("lancode");
  const menuDetails = useSelector((state) => state.landing.menuDetails);

  const getMenus = (cat) => {
    const menuMain =
      menuDetails &&
      menuDetails.data &&
      menuDetails.data.filter((item) => item.categoryEN == cat);
    const subCategory =
      menuMain && menuMain.length > 0 && menuMain[0].subCategory;
    return subCategory;
  };
  return (
    <>
      <div className="bg-HeaderMobPages">
      <button onClick={()=>history.goBack()}>
        {t("Back.label")}
        </button>
        <h4><Link to="/egg">{t("Egg.label")}</Link></h4>
        <ul>
          {getMenus("egg") &&
            getMenus("egg").length > 0 &&
            getMenus("egg").map((item) => {
              return (
                <li>
                  <Link to={"/egg/" + item.subCategorySlug}>
                    {languageText === "en"
                      ? item.subCategoryEN
                      : item.subCategoryTH}
                  </Link>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export { EggMob as EggMob };
